import styled from 'styled-components';

const themes = {
  1: {
    radioBkg: 'var(--color-white)',
    radioBkgChecked: 'var(--color-black)',
    radioBkgDisabled: 'var(--color-grey-10_10)',
    radioBkgCheckedDisabled: 'var(--color-grey-13_16)',
    radioBorder: '1px solid var(--color-grey-12_30)',
    radioBorderChecked: 'none',
    radioBorderDisabled: '1px solid var(--color-grey-13_16)',
    radioBorderCheckedDisabled: 'none',
    dotBkg: 'var(--color-white)',
  },
};

const sizes = {
  l: {
    font: 'var(--font-regular-17)',
    radioGap: '12px',
    radioSize: '20px',
    dotSize: '8px',
  },
  m: {
    font: 'var(--font-regular-15)',
    radioGap: '8px',
    radioSize: '16px',
    dotSize: '6px',
  },
};

export const Container = styled.label`
  --radio-gap: ${(p) => (sizes[p.size] || sizes['m']).radioGap};
  --label-font: ${(p) => (sizes[p.size] || sizes['m']).font};
  --radio-size: ${(p) => (sizes[p.size] || sizes['m']).radioSize};
  --dot-size: ${(p) => (sizes[p.size] || sizes['m']).dotSize};
  --radio-bkg: ${(p) => (themes[p.theme] || themes['1']).radioBkg};
  --radio-bkg-checked: ${(p) => (themes[p.theme] || themes['1']).radioBkgChecked};
  --radio-bkg-disabled: ${(p) => (themes[p.theme] || themes['1']).radioBkgDisabled};
  --radio-bkg-checked-disabled: ${(p) => (themes[p.theme] || themes['1']).radioBkgCheckedDisabled};
  --radio-border: ${(p) => (themes[p.theme] || themes['1']).radioBorder};
  --radio-border-checked: ${(p) => (themes[p.theme] || themes['1']).radioBorderChecked};
  --radio-border-disabled: ${(p) => (themes[p.theme] || themes['1']).radioBorderDisabled};
  --radio-border-checked-disabled: ${(p) =>
    (themes[p.theme] || themes['1']).radioBorderCheckedDisabled};
  --dot-bkg: ${(p) => (themes[p.theme] || themes['1']).dotBkg};

  display: flex;
  align-items: center;
  cursor: pointer;
  gap: var(--radio-gap);
  font: var(--label-font);
`;

export const RadioButton = styled.input.attrs({ type: 'radio' })`
  cursor: pointer;
  visibility: hidden;
  position: relative;
  width: var(--radio-size);
  height: var(--radio-size);
  margin: 2px;

  &:before {
    content: ' ';
    display: block;
    visibility: visible;
    border-radius: 50%;
    width: var(--radio-size);
    height: var(--radio-size);
    border: var(--radio-border);
  }

  &:after {
    content: ' ';
    display: none;
    visibility: visible;
    border-radius: 50%;
    width: var(--dot-size);
    height: var(--dot-size);
    background: var(--dot-bkg);
    position: absolute;
    top: calc(50% - var(--dot-size) / 2);
    left: calc(50% - var(--dot-size) / 2);
  }

  &:checked {
    &:before {
      background: var(--radio-bkg-checked);
      border: var(--radio-border-checked);
    }

    &:after {
      display: block;
    }

    &:disabled {
      &:before {
        background: var(--radio-bkg-checked-disabled);
        border: var(--radio-border-checked-disabled);
      }
    }
  }

  &:disabled {
    &:before {
      border: var(--radio-border-disabled);
    }

    &:before {
      background: var(--radio-bkg-disabled);
    }
  }
`;
